// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__-tQpR","resendInfoText":"OnGoingPaymentBox_resendInfoText__1Cxu6"};